import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../auth/authSlice";

const RequireSuperuser = () => {
  const user = useSelector(selectCurrentUser);
  const location = useLocation();

  return user?.is_superuser
    ? <Outlet />
    : <Navigate to="/" state={{ from: location }} replace />;
};

export default RequireSuperuser;
